module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "impersonate",
    attrs: {
      "title": "Changer de compte",
      "visible": _vm.visible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "open": _vm.open,
      "close": _vm.close
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [(_vm.imitator()) ? _c('div', {
    staticClass: "row imitator",
    on: {
      "click": function($event) {
        return _vm.desimpersonate()
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('gravatar', {
    staticClass: "img-thumbnail",
    attrs: {
      "email": _vm.imitator().email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('strong', [_vm._v(_vm._s(_vm.imitator().name))]), _vm._v(" (id " + _vm._s(_vm.imitator().id) + ")\n        "), _c('div', [_vm._v(_vm._s(_vm.imitator().email))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "row",
      on: {
        "click": function($event) {
          return _vm.impersonate(user)
        }
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [_c('gravatar', {
      staticClass: "img-thumbnail",
      attrs: {
        "email": user.email
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('strong', [_vm._v(_vm._s(user.name))]), _vm._v(" (id " + _vm._s(user.id) + ")\n        "), _c('div', [_vm._v(_vm._s(user.email))])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659875a7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/ImpersonateModal.vue
// module id = 702
// module chunks = 1